module.exports = "/images/eh.svg?575f3c66d550378d2ca6f9416c3f1db2";